import { render, staticRenderFns } from "./creative-config-form.vue?vue&type=template&id=c861470a&scoped=true"
import script from "./creative-config-form.vue?vue&type=script&setup=true&lang=js"
export * from "./creative-config-form.vue?vue&type=script&setup=true&lang=js"
import style0 from "./creative-config-form.vue?vue&type=style&index=0&id=c861470a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c861470a",
  null
  
)

export default component.exports